import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4">

        {/* Top bar */}
        <div className="flex justify-between items-center h-16">

          {/* Logo */}
          <h1 className="text-xl font-bold text-green-600">
            Eat Everything
          </h1>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-6">
            <Link to="/fridge" className="nav-link">Fridge</Link>
            <Link to="/scan" className="nav-link">Scan</Link>
            <Link to="/account" className="nav-link">Account</Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {/* Simple hamburger icon */}
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {menuOpen && (
          <div className="md:hidden py-4 space-y-3">
            <Link
              to="/fridge"
              className="block text-gray-700 hover:text-green-600"
              onClick={() => setMenuOpen(false)}
            >
              Fridge
            </Link>

            <Link
              to="/scan"
              className="block text-gray-700 hover:text-green-600"
              onClick={() => setMenuOpen(false)}
            >
              Scan
            </Link>

            <Link
              to="/account"
              className="block text-gray-700 hover:text-green-600"
              onClick={() => setMenuOpen(false)}
            >
              Account
            </Link>
          </div>
        )}

      </div>
    </nav>
  );
};

export default Navbar;